module.exports = __webpack_public_path__ + "static/media/icon-module-documents-desktop.6d1093f2.svg";